import { css } from 'styled-components';

import { ThemeMode } from '@sternum/web/components/theme/main/ThemeMode.context';
import { mapObjectValues } from '@sternum/web/utils/mapObjectValues';
import { ct } from '@sternum/web/utils/theme';

export interface ScrollbarCssConfiguration {
  background: string;
  thumbBackground: string;
}

const scrollbarWidth = 4;

export const createScrollbarCss = (configurationPerTheme: Record<ThemeMode, ScrollbarCssConfiguration>) => {
  return css`
    .os-scrollbar {
      --os-size: ${scrollbarWidth * 1.8}px; // thumb + track size
      --os-handle-bg: ${ct(mapObjectValues(configurationPerTheme, (objValue) => objValue.thumbBackground))};
    }

    & * {
      scrollbar-width: thin;
      scrollbar-color: ${ct(mapObjectValues(configurationPerTheme, (objValue) => objValue.thumbBackground))}
        ${ct(mapObjectValues(configurationPerTheme, (objValue) => objValue.background))};

      &::-webkit-scrollbar {
        width: ${scrollbarWidth}px;
        height: ${scrollbarWidth}px;
      }

      &::-webkit-scrollbar-track {
        background: ${ct(mapObjectValues(configurationPerTheme, (objValue) => objValue.background))};
      }

      &::-webkit-scrollbar-thumb {
        background-color: ${ct(mapObjectValues(configurationPerTheme, (objValue) => objValue.thumbBackground))};
        border-radius: ${scrollbarWidth}px;
      }
    }
  `;
};
